export default __webpack_public_path__ + "static/media/greenhouse.ffda8da5.webp";